/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonRelayResetResponse,
    JsonRelayResetResponseFromJSON,
    JsonRelayResetResponseFromJSONTyped,
    JsonRelayResetResponseToJSON,
} from './JsonRelayResetResponse';

/**
 * 
 * @export
 * @interface ApiResultOfJsonRelayResetResponse
 */
export interface ApiResultOfJsonRelayResetResponse {
    /**
     * 
     * @type {JsonRelayResetResponse}
     * @memberof ApiResultOfJsonRelayResetResponse
     */
    data?: JsonRelayResetResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRelayResetResponse
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonRelayResetResponse
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRelayResetResponse
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRelayResetResponse
     */
    result?: ApiResultOfJsonRelayResetResponseResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonRelayResetResponseResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonRelayResetResponseFromJSON(json: any): ApiResultOfJsonRelayResetResponse {
    return ApiResultOfJsonRelayResetResponseFromJSONTyped(json, false);
}

export function ApiResultOfJsonRelayResetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonRelayResetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonRelayResetResponseFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonRelayResetResponseToJSON(value?: ApiResultOfJsonRelayResetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonRelayResetResponseToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

